import { IAddressBase } from '../../models/address';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateVenturesProps {
  address?: IAddressBase;
  appstoreId?: string;
  bio?: string;
  cnpj: string;
  email: string;
  name: string;
  phone?: string;
  playstoreId?: string;
  ref: string;
  useLinearOnboardFlow: boolean;
  bookingCancellationQueueDispatchCutoff: number;
}

export type INewVenture = IVentureBase;

export const createVenturesService = async ({
  address,
  appstoreId,
  bio,
  cnpj,
  email,
  name,
  phone,
  playstoreId,
  ref,
  useLinearOnboardFlow,
  bookingCancellationQueueDispatchCutoff,
}: ICreateVenturesProps): Promise<INewVenture> => {
  const { data } = await jhsfBookingsApi.post<INewVenture>('/ventures', {
    address,
    appstoreId,
    bio,
    cnpj,
    email,
    name,
    phone,
    playstoreId,
    ref,
    useLinearOnboardFlow,
    bookingCancellationQueueDispatchCutoff,
  });

  return data;
};
